import { useState, useEffect, useCallback, useMemo } from 'react';
import { useSkillApi } from '../../hooks/useSkillApi';
import { useSkillCategory } from '../../hooks/useSkillCategory.js';

export const useAllSkillsViewModel = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    GetSkillCategories,
    cacheOperations: { writeSkillsCategories, readSkillCategory }
  } = useSkillCategory();

  const {
    getSkills,
    deleteSkill,
    createSkill,
    updateSkill: apiUpdateSkill
  } = useSkillApi();


  const fetchSkills = useCallback(async () => {
    if (!loading) setLoading(true);
    try {
      const result = await getSkills();
      await GetSkillCategories()
      if (result.success) {
        setSkills(result.data);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [getSkills]);


  useEffect(() => {
    fetchSkills();
  }, []); 

  const handleDelete = useCallback(async (skill) => {
    try {
      const result = await deleteSkill(parseInt(skill.skill_id));
      if (result.success) {
        await fetchSkills();
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    }
  }, [deleteSkill, fetchSkills]);

  const handleCreateSkill = useCallback(async (formData) => {
    try {
      const result = await createSkill(formData);
      if (result.success) {
        await fetchSkills();
        return { success: true };
      }
    } catch (error) {
      
      throw new Error(error.message);
    }
  }, [createSkill, fetchSkills]);

  const updateSkill = useCallback(async (skillId, formData) => {
    try {
      const result = await apiUpdateSkill(skillId, formData);
      if (result.success) {
        await fetchSkills();
        return { success: true };
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }, [apiUpdateSkill, fetchSkills]);

  const getSkillCategoryName = useMemo(
    () => (id) => {
      const skillsCategories = readSkillCategory();
      const skillsCategory = skillsCategories.find(
        (skillCat) => skillCat.skill_category_id.toString() === id?.toString()
      );
      return skillsCategory?.skill_cat_name || "Unknown";
    },
    [readSkillCategory]
  );

  return {
    skills,
    loading: loading,
    error,
    refetch: fetchSkills,
    handleDelete,
    createSkill: handleCreateSkill,
    updateSkill,
    skillCategory: readSkillCategory(),
    getSkillCategoryName
  };
}; 